import React from "react";
import { Tooltip as MUITooltip } from "@mui/material";

export interface TooltipProps {
  children: React.ReactElement<unknown, any>;
  title: React.ReactNode;
  open?: boolean;
  arrow?: boolean;
  placement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  title,
  open,
  arrow = false,
  placement = "top",
}) => {
  return (
    <MUITooltip
      placement={placement}
      title={title}
      arrow={arrow}
      {...(open !== undefined ? { open } : {})}
    >
      {children}
    </MUITooltip>
  );
};

export default Tooltip;
